export { ReactComponent as Amex } from './amex.svg'
export { ReactComponent as ArrowRight } from './arrow-right.svg'
export { ReactComponent as ArrowTr } from './arrow-tr.svg'
export { ReactComponent as Building } from './building.svg'
export { ReactComponent as Calendar } from './calendar.svg'
export { ReactComponent as Cancel } from './cancel.svg'
export { ReactComponent as Check } from './check.svg'
export { ReactComponent as CheckCircle } from './check-circle.svg'
export { ReactComponent as Coin } from './coin.svg'
export { ReactComponent as Collapse } from './collapse.svg'
export { ReactComponent as Community } from './community.svg'
export { ReactComponent as DeleteCircle } from './delete-circle.svg'
export { ReactComponent as Diners } from './diners.svg'
export { ReactComponent as Discover } from './discover.svg'
export { ReactComponent as Expand } from './expand.svg'
export { ReactComponent as Flash } from './flash.svg'
export { ReactComponent as Group } from './group.svg'
export { ReactComponent as JCB } from './jcb.svg'
export { ReactComponent as Mastercard } from './mastercard.svg'
export { ReactComponent as MapPin } from './map-pin.svg'
export { ReactComponent as Menu } from './menu.svg'
export { ReactComponent as Minus } from './minus.svg'
export { ReactComponent as NavArrowDown } from './nav-arrow-down.svg'
export { ReactComponent as NavArrowLeft } from './nav-arrow-left.svg'
export { ReactComponent as NavArrowRight } from './nav-arrow-right.svg'
export { ReactComponent as Planimetry } from './planimetry.svg'
export { ReactComponent as Star } from './star.svg'
export { ReactComponent as Plus } from './plus.svg'
export { ReactComponent as Trash } from './trash.svg'
export { ReactComponent as UnionPay } from './unionpay.svg'
export { ReactComponent as ViewGrid } from './view-grid.svg'
export { ReactComponent as Visa } from './visa.svg'
export { ReactComponent as WarningCircle } from './warning-circle.svg'
export { ReactComponent as WarningTriangle } from './warning-triangle.svg'
export { ReactComponent as ZoomIn } from './zoom-in.svg'
export { ReactComponent as ZoomOut } from './zoom-out.svg'
